<template>
  <div class="search-result">
    <div class="num-info">共有 <em>{{sum}}</em> 条记录</div>
    <div v-for="(item,i) in list" :key="i">
      <div class="search-title">{{textMap[item.type]}}（{{item.count}}）</div>
      <div class="search-list">
        <div class="search-item"  v-for="(item2,ii) in item.list" :key="ii" :class="{'active':curId==item2.id}"
          v-show="item.showMore||ii<3" @click="selectChange(item,item2)">
          <span class="tree-icon" v-if="item2.orgType==2">省</span>
          <span class="tree-icon org" v-if="item2.orgType==3">市</span>
          <span class="tree-icon blue" v-if="item2.orgType==4">区</span>
          <span class="tree-icon green" v-if="item2.orgType==5">渠</span>
          <span class="dian" :class="{'red':item2.status==2}" v-if="item2.orgType"></span>
          <span class="org-name">{{item2.name}}{{item2.orgCode?'-'+item2.orgCode:''}}</span>
          <div class="info-text">
            <span class="text1" v-for="(text,iii) in item2.nameTree" :key="iii" :class="{'text2':iii==item2.nameTree.length-1}">
              {{text}}
              <Icon type="ios-arrow-forward" />
            </span>
          </div>
        </div>
      </div>
      <div class="more-btn" v-if="item.showMore&& item.list.length>3" @click="item.showMore=false">
        收起
        <Icon type="ios-arrow-up"></Icon>
      </div>
      <div class="more-btn" v-else-if=" item.list.length>3" @click="item.showMore=true">
        展开
        <Icon type="ios-arrow-down"></Icon>
      </div>
    </div>
    
  </div>
</template>

<script>
export default {
  props: ["source"],
  data() {
    return {
      list:[],
      textMap:{
        '1':'机构',
        '2':'团队',
        '3':'渠道',
      },
      sum:0,
      curId:"",
    };
  },
  watch: {
  },
  methods: {
    search(keyword){
      this.list = [];
      this.$http({
        url: '/buz/organizationBase/search',
        type: 'get',
        data: {
          keywords:keyword,
          pageNo:1,
          pageSize:3,
          source:this.source
        },
      }).then((res) => {
        const data = res.data;
        this.sum = data.countSum;
        if(data.organizations.length){
          this.list.push({
            type:1,
            count:data.organizations.length,
            list:data.organizations,
            showMore: false,
          })
        }
        if(data.groups.length){
          this.list.push({
            type:2,
            count:data.groups.length,
            list:data.groups,
            showMore: false,
          })
        }
        if(data.thirdOrgs.length){
          this.list.push({
            type:3,
            count:data.thirdOrgs.length,
            list:data.thirdOrgs,
            showMore: false,
          })
        }
      })
    },
    selectChange(data,item2){
      if(data.type==1||data.type==3){
        item2.nodeType=1
      }else{
        item2.nodeType=2
      }
      this.curId = item2.id;
      this.$emit("selectChange",data.list,item2)
    }
  },
  mounted() {
    
  }
};
</script>

<style lang="scss">
@import './searchResult.scss';
</style>
